import React from "react";

const InputField = React.forwardRef<HTMLInputElement, any>((props, ref) => {
  return (
    <>
      <div className="form-floating">
        <input
          ref={ref}
          className="form-control"
          placeholder="name@example.com"
          {...props}
        />
        <label htmlFor="floatingInput">{props?.placeholder}</label>
      </div>
    </>
  );
});

export default InputField;
